import { createFileRoute } from "@tanstack/react-router";
import { VendorEventManagerPage } from "@/components/vendor/event-manager/VendorEventManagerPage";

export const Route = createFileRoute("/vendor/event-manager")({
  head: () => ({ meta: [{ title: "Event Manager · Venue Portal" }] }),
  component: VendorEventManagerPage,
});
